class DtsAIOnePortalInfo {
  /** accessEntity */
  accessEntity = '';

  /** comment */
  comment = '';

  /** coverImage */
  coverImage = '';

  /** createTime */
  createTime = '';

  /** createUser */
  createUser = undefined;

  /** entryUrl */
  entryUrl = '';

  /** gaiaCategory */
  gaiaCategory = '';

  /** id */
  id = undefined;

  /** prime */
  prime = '';

  /** purpose */
  purpose = '';

  /** updateTime */
  updateTime = '';

  /** updateUser */
  updateUser = undefined;

  /** useCaseAiTechnology */
  useCaseAiTechnology = '';

  /** useCaseDescription */
  useCaseDescription = '';

  /** useCaseId */
  useCaseId = '';

  /** useCaseName */
  useCaseName = '';

  /** useCaseOwner */
  useCaseOwner = '';

  /** useCaseOwnerDivision */
  useCaseOwnerDivision = '';

  /** useCaseStatus */
  useCaseStatus = '';

  /** viewNum */
  viewNum = undefined;

  /** workplaceSubCategory */
  workplaceSubCategory = '';
}

class DtsActionBrowseHistoryVo {
  /** browseTime */
  browseTime = '';

  /** 点击的按钮id */
  buttonId = undefined;

  /** dept */
  dept = '';

  /** 按钮的点击信息，比如pdf地址，视频地址，链接地址，contact us的邮箱或者页面跳转地址吧啦吧啦的 */
  entity = '';

  /** id */
  id = undefined;

  /** mail */
  mail = '';

  /** 按钮所在的页面id */
  pageId = undefined;

  /** PDF = 1; VIDEO = 2; LINK = 3; CONTACT_US = 4; USE_CASE_SQUARE = 5; REGISTRATION = 6;NORMAL_BUTTON = 7; */
  type = undefined;

  /** uid */
  uid = '';

  /** userId */
  userId = undefined;
}

class DtsAiPioneerPageVo {
  /** dept */
  dept = '';

  /** id */
  id = undefined;

  /** mail */
  mail = '';

  /** updateTime */
  updateTime = '';

  /** updateUserMail */
  updateUserMail = '';

  /** updateUserName */
  updateUserName = '';

  /** username */
  username = '';
}

class DtsAkskConfigVo {
  /** accessKey */
  accessKey = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** secretKey */
  secretKey = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsAssistantFeedbackVo {
  /** true:好评 false:差评 */
  feedback = false;

  /** ask接口返回的historyId */
  historyId = undefined;

  /** 差评原因 */
  reason = '';
}

class DtsAssistantMessageVo {
  /** answer */
  answer = '';

  /** content */
  content = '';

  /** dialogueSource */
  dialogueSource = '';

  /** messageId */
  messageId = '';

  /** prompt */
  prompt = '';

  /** ASSISTANT = 1, USER = 2 */
  role = undefined;

  /** topic */
  topic = '';

  /** type */
  type = undefined;

  /** userAccount */
  userAccount = '';
}

class DtsAssistantQaInfoVo {
  /** answerContent */
  answerContent = '';

  /** id */
  id = undefined;

  /** ifFaq */
  ifFaq = false;

  /** questionContent */
  questionContent = '';

  /** type */
  type = undefined;
}

class DtsAssistantRankVo {
  /** name */
  name = '';

  /** times */
  times = undefined;
}

class DtsAssistantReplyVo {
  /** answer */
  answer = '';

  /** 本次回答记录入库的id */
  historyId = undefined;

  /** ifUseLLM */
  ifUseLLM = false;

  /** token */
  token = '';
}

class DtsBannerConfigVo {
  /** actionType */
  actionType = undefined;

  /** cover */
  cover = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** description */
  description = '';

  /** id */
  id = undefined;

  /** ifVideo */
  ifVideo = false;

  /** link */
  link = '';

  /** newCover */
  newCover = '';

  /** newVideoUrl */
  newVideoUrl = '';

  /** page */
  page = undefined;

  /** releaseDate */
  releaseDate = undefined;

  /** sort */
  sort = undefined;

  /** status */
  status = undefined;

  /** title */
  title = '';

  /** type */
  type = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** videoId */
  videoId = undefined;

  /** videoUrl */
  videoUrl = '';
}

class DtsBindRoleAndAvatarParam {
  /** avatar */
  avatar = '';

  /** avatarChanged */
  avatarChanged = false;

  /** roleIds */
  roleIds = [];

  /** userId */
  userId = undefined;
}

class DtsChannelTotalVo {
  /** detailedPV */
  detailedPV = undefined;

  /** total */
  total = undefined;
}

class DtsCommunityDataEngineerVo {
  /** certifications */
  certifications = [];

  /** certified */
  certified = '';

  /** dataAsset */
  dataAsset = undefined;

  /** dbo */
  dbo = '';

  /** dept */
  dept = '';

  /** id */
  id = undefined;

  /** partnerEmail */
  partnerEmail = '';

  /** skilledAwsService */
  skilledAwsService = '';

  /** skilledCloud */
  skilledCloud = '';

  /** skilledCodeLanguage */
  skilledCodeLanguage = '';

  /** skilledDataArea */
  skilledDataArea = '';

  /** skilledDataProcessing */
  skilledDataProcessing = '';

  /** userMail */
  userMail = '';

  /** userName */
  userName = '';

  /** userPhoto */
  userPhoto = '';
}

class DtsCommunityDataStewardVo {
  /** assets */
  assets = [];

  /** certified */
  certified = '';

  /** dataAsset */
  dataAsset = undefined;

  /** dataAssetRank */
  dataAssetRank = '';

  /** dataAssetReusAbility */
  dataAssetReusAbility = undefined;

  /** dataAssetReusAbilityRank */
  dataAssetReusAbilityRank = '';

  /** dataCoin */
  dataCoin = undefined;

  /** dataCoinRank */
  dataCoinRank = '';

  /** dbo */
  dbo = '';

  /** dept */
  dept = '';

  /** id */
  id = undefined;

  /** maxDataAsset */
  maxDataAsset = undefined;

  /** maxDataAssetReusAbility */
  maxDataAssetReusAbility = undefined;

  /** maxDataCoin */
  maxDataCoin = undefined;

  /** userMail */
  userMail = '';

  /** userName */
  userName = '';

  /** userPhoto */
  userPhoto = '';
}

class DtsCommunityEngineerParam {
  /** certification */
  certification = '';

  /** dbo */
  dbo = [];

  /** keyword */
  keyword = '';

  /** pageVo */
  pageVo = new PageVo();
}

class DtsCommunityEventsParam {
  /** events接口使用，需要传true */
  ifShow = false;

  /** pageVo */
  pageVo = new PageVo();
}

class DtsCommunityListenVo {
  /** communityUserId */
  communityUserId = undefined;

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** dept */
  dept = '';

  /** id */
  id = undefined;

  /** sort */
  sort = undefined;

  /** DATA_STEWARD = 1; DATA_ENGINEER = 2 */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** userBio */
  userBio = '';

  /** userMail */
  userMail = '';

  /** userName */
  userName = '';

  /** userPhoto */
  userPhoto = '';
}

class DtsCommunityProfileHistoryVo {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** creator */
  creator = '';

  /** dept */
  dept = '';

  /** email */
  email = '';

  /** id */
  id = undefined;

  /** DATA_STEWARD = 1; DATA_ENGINEER = 2 */
  role = undefined;

  /** ON_GOING = 1; DEPRECATED = 2 */
  status = undefined;

  /** NAME_LIST = 1; IMAGE = 2 */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** url */
  url = '';
}

class DtsCommunityProfileParam {
  /** pageVo */
  pageVo = new PageVo();

  /** DATA_STEWARD = 1; DATA_ENGINEER = 2 */
  role = undefined;
}

class DtsCommunityStewardParam {
  /** certified */
  certified = false;

  /** dbo */
  dbo = [];

  /** keyword */
  keyword = '';

  /** pageVo */
  pageVo = new PageVo();

  /** asc：升序，从小到大 desc：降序，从大到小 */
  sortByDataCoin = '';
}

class DtsCommunityUserInfoVo {
  /** certified */
  certified = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** dbo */
  dbo = '';

  /** dept */
  dept = '';

  /** id */
  id = undefined;

  /** status */
  status = undefined;

  /** DATA_STEWARD = 1; DATA_ENGINEER = 2 */
  type = undefined;

  /** uid */
  uid = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** userBio */
  userBio = '';

  /** userMail */
  userMail = '';

  /** userName */
  userName = '';

  /** userPhoto */
  userPhoto = '';
}

class DtsDetailPageViewCountParam {
  /** pageVo */
  pageVo = new PageVo();

  /** startTime */
  startTime = undefined;

  /** type */
  type = undefined;
}

class DtsFeedbackPageParam {
  /** channel */
  channel = '';

  /** endTime */
  endTime = undefined;

  /** pageVo */
  pageVo = new PageVo();

  /** startTime */
  startTime = undefined;
}

class DtsFeedbackParam {
  /** channel */
  channel = '';

  /** description */
  description = '';

  /** fileMappingObjectList */
  fileMappingObjectList = [];

  /** score */
  score = '';
}

class DtsFeedbackVo {
  /** channel */
  channel = '';

  /** createTime */
  createTime = '';

  /** createUser */
  createUser = undefined;

  /** deleteFlag */
  deleteFlag = undefined;

  /** dept */
  dept = '';

  /** description */
  description = '';

  /** id */
  id = undefined;

  /** images */
  images = [];

  /** ossJsonArrayInfo */
  ossJsonArrayInfo = '';

  /** score */
  score = '';

  /** uid */
  uid = '';

  /** username */
  username = '';
}

class DtsGlossaryVo {
  /** abbreviation */
  abbreviation = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** synonyms */
  synonyms = '';

  /** translation */
  translation = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** word */
  word = '';
}

class DtsJoinUs {
  /** createTime */
  createTime = '';

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** status */
  status = undefined;

  /** type */
  type = '';

  /** updateTime */
  updateTime = '';

  /** updateUser */
  updateUser = undefined;

  /** userId */
  userId = undefined;
}

class DtsJoinUsImportLogPageParam {
  /** fileName */
  fileName = '';

  /** pageVo */
  pageVo = new PageVo();

  /** status */
  status = '';
}

class DtsJoinUsImportLogVo {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** fileName */
  fileName = '';

  /** id */
  id = undefined;

  /** status */
  status = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** username */
  username = '';
}

class DtsNewsInfoVo {
  /** actionType */
  actionType = undefined;

  /** content */
  content = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** true = 打开，community-event也展示, false = 关闭 */
  ifEvent = false;

  /** images */
  images = [];

  /** links */
  links = [];

  /** newImages */
  newImages = [];

  /** newsDescription */
  newsDescription = '';

  /** newsDisplayTime */
  newsDisplayTime = undefined;

  /** newsReleaseTime */
  newsReleaseTime = undefined;

  /** IMAGE = 1, PDF = 2, LINK = 3 */
  newsShowType = undefined;

  /** newsTitle */
  newsTitle = '';

  /** newsViewCount */
  newsViewCount = undefined;

  /** pdfs */
  pdfs = [];

  /** draft = 1, on-going = 2 */
  status = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsNewsPageParam {
  /** ifEvent */
  ifEvent = false;

  /** ifShow */
  ifShow = false;

  /** newsDescription */
  newsDescription = '';

  /** newsTitle */
  newsTitle = '';

  /** pageId */
  pageId = undefined;

  /** pageVo */
  pageVo = new PageVo();

  /** sortByPopularity */
  sortByPopularity = '';

  /** sortByReleaseTime */
  sortByReleaseTime = '';

  /** status */
  status = undefined;
}

class DtsNotificationInfoVo {
  /** 1=save 2=submit */
  actionType = undefined;

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** true已读 */
  ifRead = false;

  /** true立即执行 */
  ifReleaseNow = false;

  /** message */
  message = '';

  /** notificationId */
  notificationId = undefined;

  /** notifyTime */
  notifyTime = undefined;

  /** 0：不推送 1：推送一次 */
  notifyTimes = undefined;

  /** releaseTime */
  releaseTime = undefined;

  /** DRAFT = 1; TO_BE_DISPLAY = 2; ON_GOING = 3; COMPLETED = 4; */
  status = undefined;

  /** targetGroup */
  targetGroup = undefined;

  /** targetGroupType */
  targetGroupType = undefined;

  /** UPDATE = 1; TOPIC = 2; GROWTH = 3; */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsNotificationPageParam {
  /** page */
  page = new PageVo();

  /** Integer UPDATE = 1; Integer TOPIC = 2; Integer GROWTH = 3; */
  status = undefined;

  /** Integer DRAFT = 1; Integer TO_BE_DISPLAY = 2; Integer ON_GOING = 3; Integer COMPLETED = 4; */
  type = undefined;
}

class DtsPermissionVo {
  /** dept */
  dept = '';

  /** dtsUseDays */
  dtsUseDays = undefined;

  /** mail */
  mail = '';

  /** permissions */
  permissions = [];

  /** roles */
  roles = [];

  /** uid */
  uid = '';

  /** username */
  username = '';
}

class DtsProductServiceVo {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** description */
  description = '';

  /** id */
  id = undefined;

  /** image */
  image = '';

  /** link */
  link = '';

  /** sort */
  sort = undefined;

  /** title */
  title = '';

  /** type */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** viewNum */
  viewNum = undefined;
}

class DtsQuestionnaireVo {
  /** answerContent */
  answerContent = [];

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** questionContent */
  questionContent = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsResourceInfoVo {
  /** children */
  children = [];

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** parentId */
  parentId = undefined;

  /** resCode */
  resCode = '';

  /** resDesc */
  resDesc = '';

  /** resLocation */
  resLocation = undefined;

  /** resName */
  resName = '';

  /** resStatus */
  resStatus = undefined;

  /** resType */
  resType = '';

  /** resUrl */
  resUrl = '';

  /** sort */
  sort = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsRoleInfoVo {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** id */
  id = undefined;

  /** roleCode */
  roleCode = '';

  /** roleDesc */
  roleDesc = '';

  /** roleName */
  roleName = '';

  /** roleStatus */
  roleStatus = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsRolePageParam {
  /** pageVo */
  pageVo = new PageVo();

  /** roleCode */
  roleCode = '';

  /** roleName */
  roleName = '';
}

class DtsRoleResVo {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** resIds */
  resIds = [];

  /** roleId */
  roleId = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;
}

class DtsSearchParam {
  /** fuzzy */
  fuzzy = '';

  /** pageNo */
  pageNo = undefined;

  /** pageSize */
  pageSize = undefined;

  /** title */
  title = '';
}

class DtsSearchVO {
  /** content */
  content = '';

  /** id */
  id = undefined;

  /** jumpName */
  jumpName = '';

  /** jumpPath */
  jumpPath = '';

  /** model */
  model = '';

  /** sourceSys */
  sourceSys = '';

  /** tag */
  tag = undefined;

  /** title */
  title = '';

  /** type */
  type = '';
}

class DtsShowroomParam {
  /** 1:OtD-Logistics 2:OtD-Shopfloor 3:IN_VEHICLE 4:QUALITY */
  dbos = [];

  /** pageVo */
  pageVo = new PageVo();

  /** status */
  status = undefined;

  /** title */
  title = '';
}

class DtsTableDataVoMapStringObjectDtsChannelTotalVo {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTableDataVoStringBigDecimal {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTableDataVoStringInteger {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTableDataVoStringLong {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTableDataVoStringMapStringInteger {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTableDataVoStringTripleIntegerIntegerInteger {
  /** xdata */
  xdata = [];

  /** ydata */
  ydata = [];
}

class DtsTrainingAddParam {
  /** bbaUrl */
  bbaUrl = '';

  /** bbaUrlDesc */
  bbaUrlDesc = '';

  /** bmwUrl */
  bmwUrl = '';

  /** bmwUrlDesc */
  bmwUrlDesc = '';

  /** LIVE = 1, OFFLINE = 2, E_LEARNING = 3 */
  calendarType = undefined;

  /** cnPdf */
  cnPdf = '';

  /** code */
  code = '';

  /** description */
  description = '';

  /** enPdf */
  enPdf = '';

  /** endTime */
  endTime = undefined;

  /** id */
  id = undefined;

  /** true:打开 false:关闭 */
  ifCalendar = false;

  /** ifGaia */
  ifGaia = false;

  /** GAIA_2_0 or GAIA_3_0 */
  gaiaType = '';

  /** ifCopilot */
  ifCopilot = false;

  /** ifLearningPath */
  ifLearningPath = false;

  /** ifNugget */
  ifNugget = false;

  /** true:打开 false:关闭 */
  ifOpenCourse = false;

  /** true:打开 false:关闭 */
  ifShowCourseList = false;

  /** ifVlog */
  ifVlog = false;

  /** lastModifyDate */
  lastModifyDate = undefined;

  /** learningPathLevel */
  learningPathLevel = [];

  /** learningPathOrder */
  learningPathOrder = undefined;

  /** learningPathRoles */
  learningPathRoles = [];

  /** BEGINNER = 1, INTERMEDIATE = 2, ADVANCED = 3 */
  level = [];

  /** location */
  location = '';

  /** pdf/video=file; bmw/bbaEntry=link; prompt=text; register=register */
  materialType = '';

  /** name */
  name = '';

  /** 提示语 */
  prompt = '';

  /** registerUrl */
  registerUrl = '';

  /** DATA_RELATED = 1, AI_RELATED = 2 */
  relatedType = undefined;

  /** releaseTime */
  releaseTime = undefined;

  /** startTime */
  startTime = undefined;

  /** READY = 1; COMING_SOON = 2 */
  status = undefined;

  /** All staff, DMGF, Data Steward, Data Engineer, Data Analyst / Use Case Owner，共5个 */
  targetGroup = [];

  /** trainer */
  trainer = '';

  /** video */
  video = '';

  /** videoId */
  videoId = undefined;
}

class DtsTrainingBackPageParam {
  /** courseName */
  courseName = '';

  /** location */
  location = '';

  /** pageVo */
  pageVo = new PageVo();

  /** All staff, DMGF, Data Steward, Data Engineer, Data Analyst / Use Case Owner，共5个 */
  targetGroup = [];
}

class DtsTrainingCertPageParam {
  /** mail */
  mail = '';

  /** pageVo */
  pageVo = new PageParam();
}

class DtsTrainingCoursePageParam {
  /** ifGaia */
  ifGaia = false;

  /** ifNugget */
  ifNugget = false;

  /** BEGINNER = 1, INTERMEDIATE = 2, ADVANCED = 3 */
  level = '';

  /** name */
  name = '';

  /** pageVo */
  pageVo = new PageVo();

  /** DATA_RELATED = 1, AI_RELATED = 2 */
  relatedType = undefined;

  /** OPEN_COURSE = 1, VLOG = 2 */
  videoType = undefined;
}

class DtsTrainingInfoVo {
  /** bbaUrl */
  bbaUrl = new DtsTrainingMaterialVo();

  /** bmwUrl */
  bmwUrl = new DtsTrainingMaterialVo();

  /** calendarType */
  calendarType = undefined;

  /** cnPdfs */
  cnPdfs = [];

  /** code */
  code = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** description */
  description = '';

  /** endTime */
  endTime = undefined;

  /** id */
  id = undefined;

  /** ifCalendar */
  ifCalendar = false;

  /** ifGaia */
  ifGaia = false;

  /** GAIA_2_0 or GAIA_3_0 */
  gaiaType = '';

  /** ifCopilot */
  ifCopilot = false;

  /** ifLearningPath */
  ifLearningPath = false;

  /** ifNugget */
  ifNugget = false;

  /** ifOpenCourse */
  ifOpenCourse = false;

  /** ifShowCourseList */
  ifShowCourseList = false;

  /** ifVlog */
  ifVlog = false;

  /** image */
  image = '';

  /** lastModifyDate */
  lastModifyDate = undefined;

  /** learningPathLevel */
  learningPathLevel = [];

  /** learningPathOrder */
  learningPathOrder = undefined;

  /** learningPathRoles */
  learningPathRoles = [];

  /** level */
  level = [];

  /** location */
  location = '';

  /** pdf/video=file; bmw/bbaEntry=link; prompt=text; register=register */
  materialType = '';

  /** name */
  name = '';

  /** pdfs */
  pdfs = [];

  /** prompt */
  prompt = '';

  /** registerUrl */
  registerUrl = new DtsTrainingMaterialVo();

  /** relatedType */
  relatedType = undefined;

  /** releaseTime */
  releaseTime = undefined;

  /** sort */
  sort = undefined;

  /** stage */
  stage = '';

  /** startTime */
  startTime = undefined;

  /** status */
  status = undefined;

  /** targetGroup */
  targetGroup = '';

  /** trainer */
  trainer = '';

  /** unsureTime */
  unsureTime = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** videos */
  videos = [];

  /** viewCount */
  viewCount = undefined;
}

class DtsTrainingListParam {
  /** courseName */
  courseName = '';

  /** ifLearningPath */
  ifLearningPath = false;

  /** learningPathLevel */
  learningPathLevel = '';

  /** learningPathRole */
  learningPathRole = '';

  /** BEGINNER = 1, INTERMEDIATE = 2, ADVANCED = 3 */
  level = undefined;

  /** location */
  location = '';

  /** DATA_RELATED = 1, AI_RELATED = 2 */
  relatedType = undefined;

  /** All staff, DMGF, Data Steward, Data Engineer, Data Analyst / Use Case Owner，共5个 */
  targetGroup = [];
}

class DtsTrainingMaterialVo {
  /** content */
  content = '';

  /** courseId */
  courseId = undefined;

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** description */
  description = '';

  /** fileName */
  fileName = '';

  /** id */
  id = undefined;

  /** sort */
  sort = undefined;

  /** type */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** videoId */
  videoId = undefined;
}

class DtsUseCaseNuggetPageParam {
  /** name */
  name = '';

  /** pageVo */
  pageVo = new PageParam();
}

class DtsUseCaseNuggetPageVo {
  /** cover */
  cover = '';

  /** createTime */
  createTime = '';

  /** createUserMail */
  createUserMail = '';

  /** createUserName */
  createUserName = '';

  /** fullCoverUrl */
  fullCoverUrl = '';

  /** fullVideoUrl */
  fullVideoUrl = '';

  /** id */
  id = undefined;

  /** name */
  name = '';

  /** updateTime */
  updateTime = '';

  /** updateUserMail */
  updateUserMail = '';

  /** updateUserName */
  updateUserName = '';

  /** videoUrl */
  videoUrl = '';
}

class DtsUseCaseNuggetSaveParam {
  /** cover */
  cover = '';

  /** id */
  id = undefined;

  /** name */
  name = '';

  /** videoUrl */
  videoUrl = '';
}

class DtsUseCaseOwnerVo {
  /** caseOwnerAvatar */
  caseOwnerAvatar = '';

  /** caseOwnerDepartment */
  caseOwnerDepartment = '';

  /** caseOwnerEmail */
  caseOwnerEmail = '';

  /** caseOwnerName */
  caseOwnerName = '';

  /** newCaseOwnerAvatar */
  newCaseOwnerAvatar = '';

  /** uuid */
  uuid = '';
}

class DtsUseCaseShowroomVo {
  /** actionType */
  actionType = undefined;

  /** background */
  background = '';

  /** benefit */
  benefit = '';

  /** caseOwnerVos */
  caseOwnerVos = [];

  /** content */
  content = '';

  /** contentDifficult */
  contentDifficult = '';

  /** contentImageJson */
  contentImageJson = '';

  /** contentImages */
  contentImages = [];

  /** contentSolution */
  contentSolution = '';

  /** contentType */
  contentType = undefined;

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** 1:OtD-Logistics  2:OtD-Shopfloor 3:IN_VEHICLE 4:QUALITY */
  dbo = undefined;

  /** description */
  description = '';

  /** displayTime */
  displayTime = undefined;

  /** id */
  id = undefined;

  /** image */
  image = '';

  /** level */
  level = undefined;

  /** link */
  link = '';

  /** newContentImages */
  newContentImages = [];

  /** newImage */
  newImage = '';

  /** releaseTime */
  releaseTime = undefined;

  /** sourceTags */
  sourceTags = [];

  /** status */
  status = undefined;

  /** tags */
  tags = [];

  /** title */
  title = '';

  /** type */
  type = undefined;

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** videoId */
  videoId = '';

  /** viewCount */
  viewCount = undefined;
}

class DtsUserInfoVo {
  /** avatar */
  avatar = '';

  /** birthDate */
  birthDate = '';

  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** dept */
  dept = '';

  /** education */
  education = undefined;

  /** guided */
  guided = false;

  /** id */
  id = undefined;

  /** mail */
  mail = '';

  /** newAvatar */
  newAvatar = '';

  /** phone */
  phone = undefined;

  /** roleIds */
  roleIds = [];

  /** roles */
  roles = [];

  /** token */
  token = '';

  /** uid */
  uid = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** username */
  username = '';
}

class DtsUserPageParam {
  /** pageVo */
  pageVo = new PageVo();

  /** mail */
  mail = '';

  /** roleIds */
  roleIds = [];

  /** uid */
  uid = '';

  /** username */
  username = '';
}

class DtsUserPortraitVo {
  /** activated */
  activated = new UserGroup();

  /** core */
  core = new UserGroup();

  /** loss */
  loss = new UserGroup();

  /** loyalty */
  loyalty = new UserGroup();

  /** totalNum */
  totalNum = undefined;
}

class DtsVideoPageParam {
  /** pageVo */
  pageVo = new PageParam();

  /** status */
  status = '';

  /** tag */
  tag = '';

  /** title */
  title = '';
}

class DtsVideoParam {
  /** createTime */
  createTime = undefined;

  /** createUser */
  createUser = undefined;

  /** duration */
  duration = undefined;

  /** id */
  id = undefined;

  /** size */
  size = undefined;

  /** status */
  status = '';

  /** tag */
  tag = [];

  /** title */
  title = '';

  /** trunkUrl */
  trunkUrl = '';

  /** updateTime */
  updateTime = undefined;

  /** updateUser */
  updateUser = undefined;

  /** url */
  url = '';

  /** videoName */
  videoName = '';
}

class DtsVideoVo {
  /** createTime */
  createTime = '';

  /** createUser */
  createUser = undefined;

  /** createUserMail */
  createUserMail = '';

  /** createUserName */
  createUserName = '';

  /** duration */
  duration = undefined;

  /** id */
  id = undefined;

  /** size */
  size = undefined;

  /** status */
  status = '';

  /** tag */
  tag = '';

  /** title */
  title = '';

  /** trunkUrl */
  trunkUrl = '';

  /** updateTime */
  updateTime = '';

  /** updateUser */
  updateUser = undefined;

  /** updateUserMail */
  updateUserMail = '';

  /** updateUserName */
  updateUserName = '';

  /** url */
  url = '';

  /** videoName */
  videoName = '';
}

class ImportResultVo {
  /** existing */
  existing = undefined;

  /** existingEmail */
  existingEmail = [];

  /** inserted */
  inserted = undefined;

  /** summary */
  summary = '';
}

class LoginResultVo {
  /** guided */
  guided = false;

  /** name */
  name = '';

  /** oidcInfo */
  oidcInfo = new SSOTokenResultVo();

  /** state */
  state = '';

  /** token */
  token = '';
}

class OSSFileMappingObject {
  /** key */
  key = '';

  /** originName */
  originName = '';
}

class PageParam {
  /** current */
  current = undefined;

  /** size */
  size = undefined;
}

class PageVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsAiPioneerPageVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsCommunityDataEngineerVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsCommunityDataStewardVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsCommunityProfileHistoryVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsFeedbackVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsJoinUsImportLogVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsNewsInfoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsNotificationInfoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsRoleInfoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsSearchVO {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsTrainingInfoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsUseCaseNuggetPageVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsUseCaseShowroomVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsUserInfoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoDtsVideoVo {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PageVoMapStringObject {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** pages */
  pages = undefined;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ResponseVo {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoBoolean {
  /** data */
  data = false;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsAssistantReplyVo {
  /** data */
  data = new DtsAssistantReplyVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsBannerConfigVo {
  /** data */
  data = new DtsBannerConfigVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsCommunityListenVo {
  /** data */
  data = new DtsCommunityListenVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsJoinUs {
  /** data */
  data = new DtsJoinUs();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsNewsInfoVo {
  /** data */
  data = new DtsNewsInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsPermissionVo {
  /** data */
  data = new DtsPermissionVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsResourceInfoVo {
  /** data */
  data = new DtsResourceInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsRoleInfoVo {
  /** data */
  data = new DtsRoleInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTableDataVoStringBigDecimal {
  /** data */
  data = new DtsTableDataVoStringBigDecimal();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTableDataVoStringInteger {
  /** data */
  data = new DtsTableDataVoStringInteger();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTableDataVoStringLong {
  /** data */
  data = new DtsTableDataVoStringLong();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTableDataVoStringMapStringInteger {
  /** data */
  data = new DtsTableDataVoStringMapStringInteger();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTableDataVoStringTripleIntegerIntegerInteger {
  /** data */
  data = new DtsTableDataVoStringTripleIntegerIntegerInteger();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsTrainingInfoVo {
  /** data */
  data = new DtsTrainingInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsUseCaseShowroomVo {
  /** data */
  data = new DtsUseCaseShowroomVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsUserInfoVo {
  /** data */
  data = new DtsUserInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsUserPortraitVo {
  /** data */
  data = new DtsUserPortraitVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoDtsVideoVo {
  /** data */
  data = new DtsVideoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoImportResultVo {
  /** data */
  data = new ImportResultVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoInteger {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsAkskConfigVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsAssistantQaInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsAssistantRankVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsBannerConfigVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsCommunityListenVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsCommunityUserInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsNotificationInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsProductServiceVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsResourceInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsRoleInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsTrainingInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListDtsUserInfoVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListInteger {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListLong {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListOSSFileMappingObject {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListSearchFuzzyTitleVo {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoListString {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoLoginResultVo {
  /** data */
  data = new LoginResultVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoLong {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapIntegerSetString {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringBigDecimal {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringDtsTableDataVoMapStringObjectDtsChannelTotalVo {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringDtsTableDataVoStringLong {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringInteger {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringListDtsAIOnePortalInfo {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringListDtsGlossaryVo {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringObject {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoMapStringString {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsAiPioneerPageVo {
  /** data */
  data = new PageVoDtsAiPioneerPageVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsCommunityDataEngineerVo {
  /** data */
  data = new PageVoDtsCommunityDataEngineerVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsCommunityDataStewardVo {
  /** data */
  data = new PageVoDtsCommunityDataStewardVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsCommunityProfileHistoryVo {
  /** data */
  data = new PageVoDtsCommunityProfileHistoryVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsFeedbackVo {
  /** data */
  data = new PageVoDtsFeedbackVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsJoinUsImportLogVo {
  /** data */
  data = new PageVoDtsJoinUsImportLogVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsNewsInfoVo {
  /** data */
  data = new PageVoDtsNewsInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsNotificationInfoVo {
  /** data */
  data = new PageVoDtsNotificationInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsRoleInfoVo {
  /** data */
  data = new PageVoDtsRoleInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsSearchVO {
  /** data */
  data = new PageVoDtsSearchVO();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsTrainingInfoVo {
  /** data */
  data = new PageVoDtsTrainingInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsUseCaseNuggetPageVo {
  /** data */
  data = new PageVoDtsUseCaseNuggetPageVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsUseCaseShowroomVo {
  /** data */
  data = new PageVoDtsUseCaseShowroomVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsUserInfoVo {
  /** data */
  data = new PageVoDtsUserInfoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoDtsVideoVo {
  /** data */
  data = new PageVoDtsVideoVo();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoPageVoMapStringObject {
  /** data */
  data = new PageVoMapStringObject();

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoSetString {
  /** data */
  data = [];

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoString {
  /** data */
  data = '';

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class ResponseVoVoid {
  /** data */
  data = undefined;

  /** msg */
  msg = '';

  /** status */
  status = '';
}

class SSOTokenResultVo {
  /** access_token */
  access_token = '';

  /** expires_in */
  expires_in = undefined;

  /** refresh_token */
  refresh_token = '';

  /** scope */
  scope = '';

  /** token_type */
  token_type = '';
}

class SearchFuzzyTitleVo {
  /** label */
  label = '';

  /** value */
  value = '';
}

class SseEmitter {
  /** timeout */
  timeout = undefined;
}

class TripleIntegerBigDecimalString {
  /** left */
  left = undefined;

  /** middle */
  middle = undefined;

  /** right */
  right = '';
}

class TripleIntegerIntegerInteger {
  /** left */
  left = undefined;

  /** middle */
  middle = undefined;

  /** right */
  right = undefined;
}

class UserGroup {
  /** allNum */
  allNum = new TripleIntegerBigDecimalString();

  /** employeeNum */
  employeeNum = new TripleIntegerBigDecimalString();

  /** supplierNum */
  supplierNum = new TripleIntegerBigDecimalString();
}

export const dtsServer = {
  DtsAIOnePortalInfo,
  DtsActionBrowseHistoryVo,
  DtsAiPioneerPageVo,
  DtsAkskConfigVo,
  DtsAssistantFeedbackVo,
  DtsAssistantMessageVo,
  DtsAssistantQaInfoVo,
  DtsAssistantRankVo,
  DtsAssistantReplyVo,
  DtsBannerConfigVo,
  DtsBindRoleAndAvatarParam,
  DtsChannelTotalVo,
  DtsCommunityDataEngineerVo,
  DtsCommunityDataStewardVo,
  DtsCommunityEngineerParam,
  DtsCommunityEventsParam,
  DtsCommunityListenVo,
  DtsCommunityProfileHistoryVo,
  DtsCommunityProfileParam,
  DtsCommunityStewardParam,
  DtsCommunityUserInfoVo,
  DtsDetailPageViewCountParam,
  DtsFeedbackPageParam,
  DtsFeedbackParam,
  DtsFeedbackVo,
  DtsGlossaryVo,
  DtsJoinUs,
  DtsJoinUsImportLogPageParam,
  DtsJoinUsImportLogVo,
  DtsNewsInfoVo,
  DtsNewsPageParam,
  DtsNotificationInfoVo,
  DtsNotificationPageParam,
  DtsPermissionVo,
  DtsProductServiceVo,
  DtsQuestionnaireVo,
  DtsResourceInfoVo,
  DtsRoleInfoVo,
  DtsRolePageParam,
  DtsRoleResVo,
  DtsSearchParam,
  DtsSearchVO,
  DtsShowroomParam,
  DtsTableDataVoMapStringObjectDtsChannelTotalVo,
  DtsTableDataVoStringBigDecimal,
  DtsTableDataVoStringInteger,
  DtsTableDataVoStringLong,
  DtsTableDataVoStringMapStringInteger,
  DtsTableDataVoStringTripleIntegerIntegerInteger,
  DtsTrainingAddParam,
  DtsTrainingBackPageParam,
  DtsTrainingCertPageParam,
  DtsTrainingCoursePageParam,
  DtsTrainingInfoVo,
  DtsTrainingListParam,
  DtsTrainingMaterialVo,
  DtsUseCaseNuggetPageParam,
  DtsUseCaseNuggetPageVo,
  DtsUseCaseNuggetSaveParam,
  DtsUseCaseOwnerVo,
  DtsUseCaseShowroomVo,
  DtsUserInfoVo,
  DtsUserPageParam,
  DtsUserPortraitVo,
  DtsVideoPageParam,
  DtsVideoParam,
  DtsVideoVo,
  ImportResultVo,
  LoginResultVo,
  OSSFileMappingObject,
  PageParam,
  PageVo,
  PageVoDtsAiPioneerPageVo,
  PageVoDtsCommunityDataEngineerVo,
  PageVoDtsCommunityDataStewardVo,
  PageVoDtsCommunityProfileHistoryVo,
  PageVoDtsFeedbackVo,
  PageVoDtsJoinUsImportLogVo,
  PageVoDtsNewsInfoVo,
  PageVoDtsNotificationInfoVo,
  PageVoDtsRoleInfoVo,
  PageVoDtsSearchVO,
  PageVoDtsTrainingInfoVo,
  PageVoDtsUseCaseNuggetPageVo,
  PageVoDtsUseCaseShowroomVo,
  PageVoDtsUserInfoVo,
  PageVoDtsVideoVo,
  PageVoMapStringObject,
  ResponseVo,
  ResponseVoBoolean,
  ResponseVoDtsAssistantReplyVo,
  ResponseVoDtsBannerConfigVo,
  ResponseVoDtsCommunityListenVo,
  ResponseVoDtsJoinUs,
  ResponseVoDtsNewsInfoVo,
  ResponseVoDtsPermissionVo,
  ResponseVoDtsResourceInfoVo,
  ResponseVoDtsRoleInfoVo,
  ResponseVoDtsTableDataVoStringBigDecimal,
  ResponseVoDtsTableDataVoStringInteger,
  ResponseVoDtsTableDataVoStringLong,
  ResponseVoDtsTableDataVoStringMapStringInteger,
  ResponseVoDtsTableDataVoStringTripleIntegerIntegerInteger,
  ResponseVoDtsTrainingInfoVo,
  ResponseVoDtsUseCaseShowroomVo,
  ResponseVoDtsUserInfoVo,
  ResponseVoDtsUserPortraitVo,
  ResponseVoDtsVideoVo,
  ResponseVoImportResultVo,
  ResponseVoInteger,
  ResponseVoListDtsAkskConfigVo,
  ResponseVoListDtsAssistantQaInfoVo,
  ResponseVoListDtsAssistantRankVo,
  ResponseVoListDtsBannerConfigVo,
  ResponseVoListDtsCommunityListenVo,
  ResponseVoListDtsCommunityUserInfoVo,
  ResponseVoListDtsNotificationInfoVo,
  ResponseVoListDtsProductServiceVo,
  ResponseVoListDtsResourceInfoVo,
  ResponseVoListDtsRoleInfoVo,
  ResponseVoListDtsTrainingInfoVo,
  ResponseVoListDtsUserInfoVo,
  ResponseVoListInteger,
  ResponseVoListLong,
  ResponseVoListOSSFileMappingObject,
  ResponseVoListSearchFuzzyTitleVo,
  ResponseVoListString,
  ResponseVoLoginResultVo,
  ResponseVoLong,
  ResponseVoMapIntegerSetString,
  ResponseVoMapStringBigDecimal,
  ResponseVoMapStringDtsTableDataVoMapStringObjectDtsChannelTotalVo,
  ResponseVoMapStringDtsTableDataVoStringLong,
  ResponseVoMapStringInteger,
  ResponseVoMapStringListDtsAIOnePortalInfo,
  ResponseVoMapStringListDtsGlossaryVo,
  ResponseVoMapStringObject,
  ResponseVoMapStringString,
  ResponseVoPageVoDtsAiPioneerPageVo,
  ResponseVoPageVoDtsCommunityDataEngineerVo,
  ResponseVoPageVoDtsCommunityDataStewardVo,
  ResponseVoPageVoDtsCommunityProfileHistoryVo,
  ResponseVoPageVoDtsFeedbackVo,
  ResponseVoPageVoDtsJoinUsImportLogVo,
  ResponseVoPageVoDtsNewsInfoVo,
  ResponseVoPageVoDtsNotificationInfoVo,
  ResponseVoPageVoDtsRoleInfoVo,
  ResponseVoPageVoDtsSearchVO,
  ResponseVoPageVoDtsTrainingInfoVo,
  ResponseVoPageVoDtsUseCaseNuggetPageVo,
  ResponseVoPageVoDtsUseCaseShowroomVo,
  ResponseVoPageVoDtsUserInfoVo,
  ResponseVoPageVoDtsVideoVo,
  ResponseVoPageVoMapStringObject,
  ResponseVoSetString,
  ResponseVoString,
  ResponseVoVoid,
  SSOTokenResultVo,
  SearchFuzzyTitleVo,
  SseEmitter,
  TripleIntegerBigDecimalString,
  TripleIntegerIntegerInteger,
  UserGroup,
};
